import { GraphQLQuery } from 'lib/graphqlClient';

const name = 'csearchWidget_FacetOptions';

const graphqlQuery: GraphQLQuery = {
	name,
	query: `
    query ${name} ($filters: String, $qualifiers: String) {
      cruiseSearch(filters: $filters, qualifiers: $qualifiers) {
        filters {
          key
          facets {
            code
            count
          }
        }
      }
    }
  `,
};

export default graphqlQuery;
